import { createAsyncThunk } from '@reduxjs/toolkit';
const typeCheckIdInSource = (source) => {
    return 'id' in source;
};
const typeCheckValueIsKeyLike = (value) => {
    return typeof value === 'number' || typeof value === 'string';
};
export const getNewStateById = (byId, source, keyAttr) => {
    return source.reduce((newStateById, sourceObject) => {
        let id;
        if (typeof keyAttr === 'function') {
            id = keyAttr(sourceObject);
        }
        else if (keyAttr !== undefined) {
            const sourceObjectAttrValue = sourceObject[keyAttr];
            if (typeCheckValueIsKeyLike(sourceObjectAttrValue)) {
                id = sourceObjectAttrValue;
            }
        }
        else if (typeCheckIdInSource(sourceObject)) {
            id = sourceObject.id;
        }
        if (typeof id !== 'undefined') {
            newStateById[id] = sourceObject;
        }
        return newStateById;
    }, Object.assign({}, byId));
};
export const getNewStateByAttr = (byId, attr, keyAttr) => {
    const initState = {};
    return Object.values(byId).reduce((newStateByAttr, sourceObject) => {
        let id;
        if (typeof keyAttr === 'function') {
            id = keyAttr(sourceObject);
        }
        else if (keyAttr !== undefined) {
            const sourceObjectKeyAttrValue = sourceObject[keyAttr];
            if (typeCheckValueIsKeyLike(sourceObjectKeyAttrValue)) {
                id = sourceObjectKeyAttrValue;
            }
        }
        else if (typeCheckIdInSource(sourceObject)) {
            id = sourceObject.id;
        }
        if (typeof id !== 'undefined') {
            const attrValue = typeof attr === 'function' ? attr(sourceObject) : sourceObject[attr];
            if (typeof attrValue === 'number' || typeof attrValue === 'string') {
                if (!newStateByAttr[attrValue]) {
                    newStateByAttr[attrValue] = [];
                }
                newStateByAttr[attrValue].push(id);
            }
        }
        return newStateByAttr;
    }, initState);
};
export const clearUserData = createAsyncThunk('global/clearUserData', () => Promise.resolve());
export default {
    clearUserData,
    getNewStateByAttr,
    getNewStateById
};
